// extracted by mini-css-extract-plugin
export default {"card_list":"style-module_card_list_DLqoFZ","cardList":"style-module_card_list_DLqoFZ"};